models.service('AssetModel', [
    'Utils',
    function (Utils) {
        function Asset(data, isActive, isFavorite) {
            var self = this;

            self.id = data.id;
            self.outputName = data.OutputName;
            self.contractSize = data.ContractSize;
            self.category = data.Category;
            self.currency = data.Currency;
            self.description = data.Description;
            self.digits = data.Digits;
            self.isShow = Utils.toBoolean(data.IsShow);
            self.isTradeable = data.IsTradeable;
            self.isClean = data.IsClean === 1;
            self.marginMode = data.MarginMode;
            self.markup = data.Markup;
            self.profitMode = data.ProfitMode;
            self.percentage = data.Percentage;
            self.initialMargin = data.InitialMargin;
            self.tickSize = data.TickSize;
            self.tickPrice = data.TickValue;
            self.openPrice = 0;
            self.closePrice = 0;
            self.isActive = isActive;
            self.s = data.s;
            self.isEsma = data.isEsma;

            self.bid = data.Bid;
            self.ask = data.Ask;
            self.high = data.High;
            self.low = data.Low;
            self.lastPrice = data.LastPrice;
            self.lastUpdateTime = data.TickTime;

            self.action = null;
            self.bidDirection = '';
            self.askDirection = '';
            self.isClient = data.isClient;
            self.isFavorite = isFavorite || false;
            self.prevAsk = data.Ask;
            self.prevBid = data.Bid;
            self.displayName = formatAssetName(data.OutputName, data.Category);
            self.tradingTimes = data.TradingTimes ? formatTradingTimes(data.TradingTimes) : '';
            self.spread = data.Spread;
            self.swapsLong = data.SwapsLong;
            self.swapsShort = data.SwapsShort;
            self.swapsCode = data.SwapsCode !== null && data.SwapsCode >= 0 ? data.SwapsCode : 3;
            self.maxLot = data.MaxLot;
            self.minLot = data.MinLot;
            self.stepLot = data.StepLot;
            self.unit = data.Unit;
            self.expiration = data.Expiration * 1000;  // convert to milliseconds
            self.isSessionValid = data.IsCurrentSessionValid;
            self.stopLevels = data.StopLevels;

            self.baseCurrency = self.profitMode === 0 ? self.s.substr(0, 6).slice(-3) : self.currency;
            self.ending = self.profitMode === 0 ? self.s.substr(6) : '';
            self.swapsCurrency = self.swapsCode === 2 ? self.baseCurrency : self.currency;

            self.convAssets = [];
            self.convAssetsMargin = [];

            self.displayOrder = data.DisplayOrder || 0;
            self.quickAccess = Utils.toBoolean(data.QuickAccess) || false;

            self.tradingConditions = data.TradingConditions || '';
            self.lotDigits = Utils.extractDigits(self.minLot) || 2;

            this.dailyChange = function () {
                var dalyPercentage = self.lastPrice !== 0 ?
                    ((self.bid - self.lastPrice) / self.lastPrice) * 100 :
                    0;
                return parseFloat(dalyPercentage.toFixed(2)) === 0 ? Math.abs(dalyPercentage).toFixed(2) : dalyPercentage.toFixed(2);
            };

            this.dailyChangeRender = function (){
                return self.dailyChange() > 0 ? 'up' : 'down';
            };

            this.markupBid = function () {
                if (self.markup > 0) {
                    return self.bid - ( Math.floor(self.markup / 2) * (1 / Math.pow(10, self.digits)) )
                }
                if (self.markup < 0) {
                    return self.bid - ( (self.markup - Math.floor(self.markup / 2)) * (1 / Math.pow(10, self.digits)) )
                }
                return self.bid;
            };

            this.markupAsk = function () {
                if (self.markup > 0) {
                    return self.ask + ( (self.markup - Math.floor(self.markup / 2)) * (1 / Math.pow(10, self.digits)) )
                }
                if (self.markup < 0) {
                    return self.ask + ( (Math.floor(self.markup / 2)) * (1 / Math.pow(10, self.digits)) )
                }
                return self.ask;
            };

            this.spreadCalc = function() {
                return self.spread > 0 ? self.spread + self.markup : 0;
            };

            this.update = function (data) {
                var _bid = parseFloat(data[1]);
                var _ask = parseFloat(data[2]);

                self.bidDirection = self.prevBid < self.bid ? 'asset-up' : 'asset-down';
                self.askDirection = self.prevAsk < self.ask ? 'asset-up' : 'asset-down';

                self.prevAsk = self.ask;
                self.prevBid = self.bid;

                self.high = data[3];
                self.low = data[4];
                self.lastUpdateTime = data[5];
                self.lastPrice = data[6];

                self.bid = _bid;
                self.ask = _ask;
            };

            function formatTradingTimes(data) {
                var tradingTimes = {};

                function padNumber(value) {
                    return (value.toString().length === 1) ? ("0" + value) : value;
                }

                function parseRange(range) {
                    return [
                        padNumber(range.OpenHour) + ':' + padNumber(range.OpenMinute),
                        padNumber(range.CloseHour) + ':' + padNumber(range.CloseMinute)
                    ];
                }

                function parseDay(ranges) {
                    var result = [];

                    ranges.forEach(function (range) {
                        result.push(parseRange(range));
                    });

                    return result;
                }

                function process(day) {
                    tradingTimes[day] = parseDay(data[day]);
                }

                Object.keys(data).map(process);

                //console.log(tradingTimes);
                return tradingTimes;
            }

            function formatAssetName(name, category) {
                if (category == 'FOREX') {
                    return name.slice(0, 3) + '/' + name.slice(3);
                }

                return name;
            }

            function noop() {
            }

            this.clear = function () {
                self.dailyChange = noop;
                self.markupBid = noop;
                self.markupAsk = noop;
                self.update = noop;
                self.spreadCalc = noop;
            };

            this.setConvAssets = function (convAssets) {
                self.convAssets = convAssets;
            };

            this.setConvAssetsMargin = function (convAssets) {
                self.convAssetsMargin = convAssets;
            };

        }

        return Asset;

    }]);
